import React, { Dispatch, SetStateAction } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';

import { UseOutletContextPurchase } from '../Purchase';
import { User } from '../../../../models/user.model';
import { AppService } from '../../../../models/app.service.model';
import { Company } from '../../../../models/company.model';
import { Settings } from '../../../../models/settings.model';
import { Contact } from '../../../../models/contact.model';
import { TreasuryAccount } from '../../../../models/treasury.account.model';
import { Service } from '../../../../models/service.model';
import { Product } from '../../../../models/product.model';
import { StorageCenter } from '../../../../models/storage.center.model';

export interface ConsignmentPageProps {};

type ContexType = {
  setRoute: Dispatch<SetStateAction<{path: {root: string, branch: string} | null, company: boolean} | null>>,
  userLoggedIn: User | null,
  appServiceForUser: AppService | null,
  companyForUser: Company | null,
  settingsForCompany: Settings | null,
  treasuryAccountsForCompany: TreasuryAccount[] | null,
  contactsForCompany: Contact[] | null,
  servicesForCompany: Service[] | null,
  productsForCompany: Product[] | null,
  storageCentersForCompany: StorageCenter[] | null,
  loadContactsForCompany: Function,
  loadStorageCentersForCompany: Function
};

const ConsignmentPage: React.FunctionComponent<ConsignmentPageProps> = props => {
  const {setRoute, userLoggedIn, appServiceForUser, companyForUser, settingsForCompany, treasuryAccountsForCompany, contactsForCompany, servicesForCompany, productsForCompany, storageCentersForCompany, loadContactsForCompany, loadStorageCentersForCompany} = UseOutletContextPurchase()

  return (
    <Outlet context={{setRoute, userLoggedIn, appServiceForUser, companyForUser, settingsForCompany, treasuryAccountsForCompany, contactsForCompany, servicesForCompany, productsForCompany, storageCentersForCompany, loadContactsForCompany, loadStorageCentersForCompany}}></Outlet>
  );
}

export function UseOutletContextConsignment() {
  return useOutletContext<ContexType>()
};

export default ConsignmentPage;
